// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2214":"c67ba86440153342","8879":"2039f5f295f110e9"}[chunkId] + ".css";
};